import { SHADOWS, GRAY_COLORS } from '../globalTheme';

export const theme = {
	dropdown: {
		button: {
			border: `1px solid ${GRAY_COLORS.gray300}`,
			boxShadow: SHADOWS.xs,
			borderRadius: '8px',
			padding: '10px 16px',
			gap: '8px'
		},
		open: {
			boxShadow: `0px 0px 0px 4px #f2f4f7, ${SHADOWS.xs}`
		},
		content: {
			width: '240px',
			borderRadius: '8px',
			border: `1px solid ${GRAY_COLORS.gray100}`,
			boxShadow: SHADOWS.lg,
			marginTop: '10px'
		}
	}
};

export type Theme = typeof theme;
